import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { sendAction } from '../../utils/api';

import './Navigation.css';

function Navigation({ handleFeedback }) {
  const location = useLocation();
  const navigate = useNavigate();
  const showFeedback = true;

  const [sectionActive, setSectionActive] = useState('guide');

  const handleNavigate = useCallback(async section => {
    if (section !== sectionActive) {
      sendAction('navigate', null, { section });
      navigate('/' + section);
      setSectionActive(section);
    }
  }, [navigate, sectionActive]);

  useEffect(() => {
    if (location?.pathname) {
      const parts = location.pathname.split('/');
      
      if (parts.length > 1) {
        setSectionActive(parts[1]);
      }
    }
  }, [location]);

  return (
    <>
      <div id="navigation">
        {/*
        <div className={'section' + (sectionActive === 'explore' ? ' active' : '')} title="Explore" onClick={() => handleNavigate('explore')}>
          <img src={process.env.PUBLIC_URL + '/assets/icons/explore.svg'} alt="Explore" />
        </div>
        */}
        <div className={'section' + (sectionActive === 'guide' ? ' active' : '')} title="Guide" onClick={() => handleNavigate('guide')}>
          <img src={process.env.PUBLIC_URL + '/assets/icons/guide.svg'} alt="Guide" />
        </div>
        <div className={'section' + (sectionActive === 'path' ? ' active' : '')} title="Path" onClick={() => handleNavigate('path')}>
          <img src={process.env.PUBLIC_URL + '/assets/icons/path.svg'} alt="Path" />
        </div>
        <div className={'section' + (sectionActive === 'bookmarks' ? ' active' : '')} title="Bookmarks" onClick={() => handleNavigate('bookmarks')}>
          <img src={process.env.PUBLIC_URL + '/assets/icons/bookmarks.svg'} alt="Bookmarks" />
        </div>
        <div className={'section' + (sectionActive === 'profile' ? ' active' : '')} title="Profile" onClick={() => handleNavigate('profile')}>
          <img src={process.env.PUBLIC_URL + '/assets/icons/profile.svg'} alt="Profile" />
        </div>
      </div>
      {showFeedback ? (
        <div id="feedback" onClick={() => handleFeedback(true)}>
          <img src={process.env.PUBLIC_URL + '/assets/icons/feedback.svg'} alt="Feedback" /><span>Please give us feedback!</span>
        </div>
      ) : null}
    </>
  );
}

export default Navigation;
